angular.module('uofa.agentsportal')

/**
 * Applicants controller for display of applicants.
 *
 * @author Michael Wolfindale <m.wolfindale@abdn.ac.uk>
 */
.controller('ApplicantsCtrl', function ApplicantsCtrl($scope, $http, $location) {

  $http.get(window.angular_datasources.config.app.url + '/api/v1/applicants').success(function(applicants) {
    $scope.applicants = applicants;
  });

  // Applicant order.
  $scope.applicantOrderBy = 'surname';

  // Applicant search.
  var applicantSearchQueryKey = "search";

  $scope.$watch(function () { return $location.search(); }, function() {
    $scope.applicantSearchQuery = $location.search()[applicantSearchQueryKey] || "";
  });

  $scope.$watch('applicantSearchQuery', function(applicantSearchQuery) {
     $location.search(applicantSearchQueryKey, applicantSearchQuery);
  });

  $scope.changeMode = function(mode) {
      $scope.mode = 'mode-on mode-' + mode;

      if (mode === 'search-close') {
          $scope.applicantSearchQuery = '';
      }
  }

  $scope.initialMode = function() {
    var applicantSearchKey = "search";

    initialMode = $location.search()[applicantSearchKey] ? 'search-application' : 'search-close';

    $scope.changeMode(initialMode);
  }

  // Search box filter.
  $scope.applicantSearch = function (applicant) {
      // If empty, show all.
      if ($scope.applicantSearchQuery === '') return true;

      // The various fields searched through.
      return (
        angular.lowercase(applicant.personal_id).indexOf(angular.lowercase($scope.applicantSearchQuery) || '') !== -1 ||
        angular.lowercase(applicant.forename1).indexOf(angular.lowercase($scope.applicantSearchQuery) || '') !== -1 ||
        angular.lowercase(applicant.surname).indexOf(angular.lowercase($scope.applicantSearchQuery) || '') !== -1 ||
        angular.lowercase(applicant.email).indexOf(angular.lowercase($scope.applicantSearchQuery) || '') !== -1 ||
        angular.lowercase(applicant.forename1 + ' ' + applicant.surname).indexOf(angular.lowercase($scope.applicantSearchQuery) || '') !== -1 ||
        angular.lowercase(applicant.title + ' ' + applicant.forename1 + ' ' + applicant.surname).indexOf(angular.lowercase($scope.applicantSearchQuery) || '') !== -1
      );
  }

});
